<template>
<div>
    <div class="row g-3 mb-4 align-items-center justify-content-between">
        <div class="col-auto">
            <h1 class="app-page-title mb-0">{{ __('admins.manage-admins-title') }}</h1>
        </div>
        <div class="col-auto">
            <div class="page-utilities">
                <div class="row g-2 justify-content-start justify-content-md-end align-items-center">
                    <div class="col-auto">
                        <a class="btn app-btn-secondary" href="#" @click.prevent="addUser">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            {{ __('actions.create') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="admins.length > 0">
    <div class="app-card app-card-orders-table shadow-sm mb-5">
        <div class="app-card-body">
            <div class="table-responsive">
                <table class="table app-table-hover mb-0 text-left">
                    <thead>
                    <tr>
                        <th class="cell">{{ __('admins.name') }}</th>
                        <th class="cell">{{ __('admins.email') }}</th>
                        <th class="cell"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(admin, index) in admins" :key="index">
                        <td class="cell">{{admin.name}}</td>
                        <td class="cell">{{admin.email}}</td>
                        <td class="cell">
                            <a class="btn app-btn-secondary" href="#" @click.prevent="getUser(admin)">{{ __('actions.edit') }}</a>
                            <a class="btn app-btn-danger" v-if="admin.id !== userProp.id" href="#" @click.prevent="deleteUser(admin)">{{ __('actions.delete') }}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
        <pagination-component :pagination="pagination" @paginate="getAdmins()"></pagination-component>
    </div>
    <div v-else class="app-card alert alert-dismissible shadow-sm mb-5 border-left-decoration" role="alert">
        <div class="inner">
            <div class="app-card-body p-3 p-lg-4">
                <h3 class="mb-3">{{ __('admins.no-admins-title') }}</h3>
                <div class="row gx-5 gy-3">
                    <div class="col-12 col-lg-9">

                        <div>{{ __('admins.no-admins-text') }}</div>
                    </div>
                    <div class="col-12 col-lg-3">
                        <a class="btn app-btn-primary" href="#" @click.prevent="addUser">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>{{ __('admins.add') }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <admin-modal ref="AdminUserModal" @update="getAdmins"></admin-modal>
</div>
</template>

<script>
export default {
    name: "adminsComponents",

    props : {
        userProp: {
            required: true,
        }
    },

    data () {
        return {
            admins: [],
            pagination: {
                current_page: 1
            },
            role: 'admin'
        }
    },

    created () {
        this.getAdmins();
    },

    methods: {
        getAdmins: function (){
            axios.get(`/get-admins/?page=${this.pagination.current_page}`)
                .then(response => {
                    this.admins = response.data.admins.data
                    this.pagination = response.data.admins
                })
        },

        getUser: function (user) {
            this.$refs.AdminUserModal.setUser(user)
            $('#AdminUserModal').modal('show')
        },

        addUser: function () {
            this.$refs.AdminUserModal.setRole(this.role)
            $('#AdminUserModal').modal('show')
        },

        deleteUser: function (admin) {
            Swal.fire({
                title: this.__('actions.confirm'),
                text: this.__('actions.confirm-text'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText:  this.__('actions.confirm-yes'),
                cancelButtonText:  this.__('actions.confirm-no'),
                showLoaderOnConfirm: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                reverseButtons: true,
                preConfirm: login => {
                    return axios.delete(`/admins/${admin.id}`).then(response => {
                        return response.data
                    })
                        .catch(error => {
                            Swal.showValidationMessage(`Something went Wrong!: ${error}`)
                        })
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then(result => {
                if (result.value) {
                    Toast.fire({icon: 'success', title: result.value.message})
                    this.getAdmins()
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
